// refine:homepage-refactor - conversion-focused sections for CTO/CMO/Founder buyers
import React from 'react';
import { Navigation } from './navigation';
import { HeroSection } from './hero-section';
import { ServicesOverview } from './services-overview';
import { WebsiteDetailPanel } from './website-detail-panel';
import { AppDevelopmentProcess } from './app-development-process';
import { TechnologyShowcase } from './technology-showcase';
import { PricingSection } from './pricing-section';
import { ProblemsSection } from './problems-section';
import { AppShowcase } from './app-showcase';
import { ResultsSection } from './results-section';
import { AppSuccessStories } from './app-success-stories';
import { WhyBusinessesChooseUs } from './why-businesses-choose-us';
import { CommonQuestions } from './common-questions';
import { ContactFormSection } from './contact-form-section';
import { Footer } from './footer';

export const Homepage = () => {
  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      {/* Skip link for keyboard users */}
      <a 
        href="#main-content" 
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-6 focus:py-3 focus:bg-primary focus:text-white focus:rounded-lg"
      >
        Skip to main content
      </a>
      
      <Navigation />
      <main id="main-content">
        {/* Conversion-focused sections */}
        <HeroSection />
        <ServicesOverview />
        <WebsiteDetailPanel />
        <AppDevelopmentProcess />
        <TechnologyShowcase />
        <PricingSection />
        <ProblemsSection />
        <AppShowcase />
        <ResultsSection />
        <AppSuccessStories />
        <WhyBusinessesChooseUs />
        <CommonQuestions />
        <ContactFormSection />
      </main>
      <Footer />
    </div>
  );
};